module.exports = __webpack_public_path__ + "static/media/logo_tipo_colors.1f82dead.svg";